if ( typeof QuickAddToCart !== 'function' ) {

	class QuickAddToCart extends HTMLElement {
		constructor(){
			super();
			if ( this.querySelector('product-form') ) {
				this.init();
			}
		}
		init(){
			this.querySelector('product-form').addEventListener('add-to-cart', ()=>{
				if ( ! document.body.classList.contains('template-cart') ) {
					document.getElementById('site-cart-sidebar').show();
					if ( KROWN.settings.cart_action == 'overlay') {
						document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
							elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
						});
						document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
							elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
						});
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
					};
				}
			});
		}
	}

  if ( typeof customElements.get('quick-add-to-cart') == 'undefined' ) {
		customElements.define('quick-add-to-cart', QuickAddToCart);
	}

}

// if ( typeof QuickViewProduct !== 'function' ) {

// 	class QuickViewProduct extends HTMLElement {

// 		constructor(){
// 			super();
// 			if ( this.querySelector('a') ) {
// 				this.init();
// 			}
// 		}

// 		initModalProduct(){

// 			this.quickViewModal.querySelectorAll('[data-js-close]').forEach(elm=>{
// 				elm.addEventListener('click', ()=>{
// 					this.quickViewModal.hide();
// 				});
// 			});

// 			if ( this.quickViewModal.querySelector('[data-js-product-form]') ) {
// 				this.quickViewModal.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
// 					document.getElementById('site-cart-sidebar')?.scrollTo({top: 0, behavior: 'smooth'});
// 					this.quickViewModal.hide();
// 				});
// 			}

// 			if ( Shopify && Shopify.PaymentButton ) {
// 				setTimeout(()=>{
// 					Shopify.PaymentButton.init();
// 				}, 50);
// 			}

// 			const productVariants = this.quickViewModal.querySelector('product-variants');
// 			if ( ! productVariants._defaultToFirstVariant ) {
// 				if ( parseInt(productVariants.dataset.variants) == 1 ) {
// 					productVariants.updateBuyButtons();
// 					this.quickViewModal.querySelector('product-page').onVariantChangeHandler({target:productVariants});
// 				}
// 			}

// 		}

// 		init(){

// 			this.quickViewModal = null;
// 			this.querySelector('a').addEventListener('keydown', e=>{
// 				if ( e.keyCode == window.KEYCODES.RETURN ) {
// 					window.lastFocusedElm = this.querySelector('a');
// 				}
// 			})
// 			this.querySelector('a').addEventListener('click', e=>{

// 				e.preventDefault();

// 				if ( ! this.quickViewModal ) {

// 					const target = e.currentTarget;

// 					target.classList.add('working');

// 					fetch(`${target.getAttribute('href')}${ target.getAttribute('href').includes('?') ? '&' : '?' }view=quick-view`)
// 						.then(response => response.text())
// 						.then(text => {

// 							const quickViewHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#product-quick-view');

// 							// create modal w content

// 							const quickViewContainer = document.createElement('div');
// 							quickViewContainer.innerHTML = `<modal-box id="modal-${target.dataset.id}"	
// 								class="modal modal--product" 
// 								data-options='{
// 									"enabled": false,
// 									"showOnce": false,
// 									"blockTabNavigation": true
// 								}'
// 								tabindex="-1" role="dialog" aria-modal="true" 
// 							>
// 								<div class="container--medium">
// 									<div class="modal-content" data-js-product-page>
// 										<button class="modal-close" data-js-close style="position:absolute;margin:0;top:0;right:0">${window.KROWN.settings.symbols.close}</button>
// 									</div>
// 								</div>
// 								<span class="modal-background" data-js-close></span>
// 							</modal-box>`;

// 							this.quickViewModal = quickViewContainer.querySelector('modal-box');
// 							document.body.appendChild(this.quickViewModal);
// 							this.quickViewModal.querySelector('.modal-content').innerHTML = quickViewHTML.innerHTML;

// 							setTimeout(()=>{
// 								this.initModalProduct();
// 							}, 100);
// 							this.quickViewModal.querySelector('[data-js-product-page]').addEventListener('reload', ()=>{
// 								this.initModalProduct();
// 							});

// 							if ( ! window.productPageScripts ) {
// 								const scripts = this.quickViewModal.querySelectorAll('script');
// 								scripts.forEach(elm=>{
// 									const script = document.createElement('script');
// 									script.src = elm.src;
// 									document.body.append(script);
// 									window.productPageScripts = true;
// 								});
// 							}

// 							setTimeout(()=>{
// 								this.quickViewModal.show();
// 								target.classList.remove('working');
// 							}, 250);
// 							Recharge.widgets.init();
// 						});

// 				} else {
// 					this.quickViewModal.show();
// 				}

// 			})
// 		}
// 	}

//   if ( typeof customElements.get('quick-view-product') == 'undefined' ) {
// 		customElements.define('quick-view-product', QuickViewProduct);
// 	}

// }

/**=================new code====================**/
if (typeof QuickViewProduct !== 'function') {

  function getDeliveryDateValue(scopeEl) {
    var v =
      (window.nextDeliveryDateValue != null ? String(window.nextDeliveryDateValue) : '') ||
      (window.next_delivery_date != null ? String(window.next_delivery_date) : '') ||
      (window.deliveryDate != null ? String(window.deliveryDate) : '') ||
      (window.DELIVERY_DATE != null ? String(window.DELIVERY_DATE) : '');

    v = (v || '').trim();
    if (v) return v;

    var $scope = scopeEl ? $(scopeEl) : $(document);

    var inputVal = ($scope.find('input[name="properties[Delivery Date]"]').val() || '').toString().trim();
    if (inputVal) return inputVal;

    var $nonModalText = $('.next-delivery-date').not($scope.find('.next-delivery-date'));
    var txt = ($nonModalText.first().text() || '').trim();
    if (txt) return txt;

    return '';
  }

  function setUI(value, scopeEl) {
    var v = (value || '').toString().trim();
    if (!v) return;

    var $scope = scopeEl ? $(scopeEl) : $(document);

    $scope.find('.next-delivery-date').each(function () {
      $(this).text(v);
    });

    $scope.find('input[name="properties[Delivery Date]"]').val(v);
  }

  class QuickViewProduct extends HTMLElement {

    constructor() {
      super();
      if (this.querySelector('a')) {
        this.init();
      }
    }

    rechargeQuickViewInit() {
      function reRenderWebComponent(element) {
        if (!element) return;
        const newEl = element.cloneNode(true);
        element.replaceWith(newEl);
      }

      function reExecuteScripts(container, attrReplace = (attr) => attr.value) {
        if (!container) return;
        const scripts = container.querySelectorAll("script");
        scripts.forEach((oldScript) => {
          const newScript = document.createElement("script");
          for (const attr of oldScript.attributes) {
            newScript.setAttribute(attr.name, attrReplace(attr));
          }
          if (oldScript.textContent) {
            newScript.textContent = oldScript.textContent;
          }
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });
      }

      if (window.__rbQuickviewLoadedBound) return;
      window.__rbQuickviewLoadedBound = true;

      document.addEventListener("quickview:loaded", function (evt) {
        const modal = evt && evt.detail && evt.detail.modal ? evt.detail.modal : document;
        const widgetContainer = modal.querySelector(".recharge-subscription-widget") || document.querySelector(".recharge-subscription-widget");
        if (widgetContainer) {
          reExecuteScripts(widgetContainer);
          reRenderWebComponent(widgetContainer.querySelector("recharge-subscription-widget"));
        }
        var val = getDeliveryDateValue(modal);
        if (val) {
          setUI(val, modal);
          setTimeout(function () { setUI(val, modal); }, 150);
          setTimeout(function () { setUI(val, modal); }, 500);
        }
      });
    }

    initModalProduct() {

      this.quickViewModal.querySelectorAll('[data-js-close]').forEach(elm => {
        elm.addEventListener('click', () => {
          this.quickViewModal.hide();
        });
      });

      if (this.quickViewModal.querySelector('[data-js-product-form]')) {
        this.quickViewModal.querySelector('[data-js-product-form]').addEventListener('add-to-cart', () => {
          document.getElementById('site-cart-sidebar')?.scrollTo({ top: 0, behavior: 'smooth' });
          this.quickViewModal.hide();
        });
      }

      if (Shopify && Shopify.PaymentButton) {
        setTimeout(() => {
          Shopify.PaymentButton.init();
        }, 50);
      }

      const productVariants = this.quickViewModal.querySelector('product-variants');
      if (productVariants && !productVariants._defaultToFirstVariant) {
        if (parseInt(productVariants.dataset.variants) == 1) {
          productVariants.updateBuyButtons();
          this.quickViewModal.querySelector('product-page')?.onVariantChangeHandler({ target: productVariants });
        }
      }

      var val = getDeliveryDateValue(this.quickViewModal);
      if (val) {
        setUI(val, this.quickViewModal);
        setTimeout(() => setUI(val, this.quickViewModal), 150);
      }
    }

    init() {

      this.quickViewModal = null;
      this.rechargeQuickViewInit();

      this.querySelector('a').addEventListener('keydown', e => {
        if (e.keyCode == window.KEYCODES.RETURN) {
          window.lastFocusedElm = this.querySelector('a');
        }
      });

      this.querySelector('a').addEventListener('click', e => {

        e.preventDefault();

        if (!this.quickViewModal) {

          const target = e.currentTarget;
          target.classList.add('working');

          fetch(`${target.getAttribute('href')}${target.getAttribute('href').includes('?') ? '&' : '?'}view=quick-view`)
            .then(response => response.text())
            .then(text => {

              const quickViewHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#product-quick-view');

              const quickViewContainer = document.createElement('div');
              quickViewContainer.innerHTML = `<modal-box id="modal-${target.dataset.id}" class="modal modal--product" data-options='{"enabled": false,"showOnce": false,"blockTabNavigation": true}' tabindex="-1" role="dialog" aria-modal="true"><div class="container--medium"><div class="modal-content" data-js-product-page><button class="modal-close" data-js-close style="position:absolute;margin:0;top:0;right:0">${window.KROWN.settings.symbols.close}</button></div></div><span class="modal-background" data-js-close></span></modal-box>`;

              this.quickViewModal = quickViewContainer.querySelector('modal-box');
              document.body.appendChild(this.quickViewModal);

              this.quickViewModal.querySelector('.modal-content').innerHTML = quickViewHTML ? quickViewHTML.innerHTML : '';

              var val = getDeliveryDateValue(this.quickViewModal);
              if (val) setUI(val, this.quickViewModal);

              setTimeout(() => {
                this.initModalProduct();
              }, 100);

              this.quickViewModal.querySelector('[data-js-product-page]')?.addEventListener('reload', () => {
                this.initModalProduct();
                var v2 = getDeliveryDateValue(this.quickViewModal);
                if (v2) {
                  setUI(v2, this.quickViewModal);
                  setTimeout(() => setUI(v2, this.quickViewModal), 150);
                }
                document.dispatchEvent(new CustomEvent('quickview:loaded', { detail: { modal: this.quickViewModal } }));
              });

              if (!window.productPageScripts) {
                const scripts = this.quickViewModal.querySelectorAll('script[src]');
                scripts.forEach(elm => {
                  const src = elm.getAttribute('src') || '';
                  if (!src) return;
                  if (src.indexOf('static.rechargecdn.com/assets/subscription-widget/subscription-widget.js') > -1) return;
                  const script = document.createElement('script');
                  script.src = src;
                  const typeAttr = elm.getAttribute('type');
                  if (typeAttr) script.setAttribute('type', typeAttr);
                  document.body.append(script);
                });
                window.productPageScripts = true;
              }

              setTimeout(() => {
                this.quickViewModal.show();
                target.classList.remove('working');

                var v3 = getDeliveryDateValue(this.quickViewModal);
                if (v3) {
                  setUI(v3, this.quickViewModal);
                  setTimeout(() => setUI(v3, this.quickViewModal), 150);
                  setTimeout(() => setUI(v3, this.quickViewModal), 500);
                }

                document.dispatchEvent(new CustomEvent('quickview:loaded', { detail: { modal: this.quickViewModal } }));
              }, 250);
            });

        } else {
          this.quickViewModal.show();

          var v4 = getDeliveryDateValue(this.quickViewModal);
          if (v4) {
            setUI(v4, this.quickViewModal);
            setTimeout(() => setUI(v4, this.quickViewModal), 150);
          }

          document.dispatchEvent(new CustomEvent('quickview:loaded', { detail: { modal: this.quickViewModal } }));
        }

      });
    }
  }

  if (typeof customElements.get('quick-view-product') == 'undefined') {
    customElements.define('quick-view-product', QuickViewProduct);
  }

}